export default __webpack_public_path__ + "static/media/8.d63808bd.mp3";